import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import api from '../services/api';
import { DEPARTMENTS, getProductDepartments } from '../utils/departments';
import SiteNavbar from './SiteNavbar';
import SiteFooter from './SiteFooter';
import ProductCard from './ProductCard';
import BackToTop from './BackToTop';

function MainSite() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/products')
      .then(res => setProducts(Array.isArray(res.data) ? res.data : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const destaques = products.filter(p => p.featured);
  const demais    = products.filter(p => !p.featured);

  // Agrupa os demais produtos por departamento, na mesma ordem da aba "Departamentos".
  // Um produto com vários departamentos aparece em cada um deles.
  const grupos = DEPARTMENTS
    .map(dept => ({ dept, itens: demais.filter(p => getProductDepartments(p).includes(dept.name)) }))
    .filter(g => g.itens.length > 0);

  // Fallback: produtos que não pertencem a nenhum departamento conhecido.
  const nomesConhecidos = new Set(DEPARTMENTS.map(d => d.name));
  const outros = demais.filter(p => !getProductDepartments(p).some(d => nomesConhecidos.has(d)));

  const renderGrid = (itens) => (
    <Row xs={1} sm={2} md={3} lg={4} className="g-4">
      {itens.map(produto => (
        <Col key={produto._id}>
          <ProductCard produto={produto} />
        </Col>
      ))}
    </Row>
  );

  return (
    <div>
      <SiteNavbar />

      <Container className="mt-4">
        {/* ── Produtos em destaque ── */}
        <h2 className="mb-4">Produtos em Destaque</h2>

        {loading && <p className="text-muted">Carregando produtos...</p>}

        {!loading && destaques.length === 0 && (
          <p className="text-muted">Nenhum produto em destaque no momento.</p>
        )}

        {destaques.length > 0 && renderGrid(destaques)}

        {/* ── Demais produtos, separados por departamento ── */}
        {!loading && grupos.map(({ dept, itens }) => (
          <section key={dept.slug} className="mt-5">
            <h3 className="mb-3" style={{ fontSize: '1.4rem' }}>{dept.name}</h3>
            {renderGrid(itens)}
            <BackToTop />
          </section>
        ))}

        {!loading && outros.length > 0 && (
          <section className="mt-5">
            <h3 className="mb-3" style={{ fontSize: '1.4rem' }}>Outros</h3>
            {renderGrid(outros)}
            <BackToTop />
          </section>
        )}
      </Container>

      <SiteFooter />
    </div>
  );
}

export default MainSite;
